<div class="search-row">
  <mat-form-field appearance="outline" class="search">
    <mat-label>Search</mat-label>
    <input matInput [(ngModel)]="searchInputValue" (keyup)="filterSearchReward()">
  </mat-form-field>
</div>

<div class="lists">
  <div class="list">
    <div class="list-header">
      <h2>{{ currentSegment === 'export' ? 'All rewards' : 'Imported rewards' }}</h2>
      @if (currentSegment === 'export') {
        <button mat-stroked-button color="primary" (click)="exportAll()">Export all</button>
      }
    </div>
    @if (filteredRewards.length <= 0) {
      <p>No rewards to show...</p>
    }
    @if (filteredRewards.length > 0) {
      <mat-selection-list>
        @for (reward of filteredRewards; track reward) {
          <mat-list-option (click)="checkboxToggleReward(reward)">
            {{reward.name}}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>

  <div class="list">
    <h2>{{ currentSegment === 'export' ? 'Selected rewards' : 'Removed rewards' }}</h2>
    @if (selectedRewards.length <= 0) {
      <p>No selected rewards to show...</p>
    }
    @if (selectedRewards.length > 0) {
      <mat-selection-list>
        @for (reward of selectedRewards; track reward) {
          <mat-list-option (click)="checkboxToggleReward(reward)">
            {{reward.name}}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  </div>
</div>

<div class="actions">
  <button mat-raised-button color="primary" (click)="sendSelectedRewards()">Save</button>
</div>
